import { render, staticRenderFns } from "./AudioRecorder.vue?vue&type=template&id=5aa840b8&scoped=true"
import script from "./AudioRecorder.vue?vue&type=script&lang=js"
export * from "./AudioRecorder.vue?vue&type=script&lang=js"
import style0 from "./AudioRecorder.vue?vue&type=style&index=0&id=5aa840b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa840b8",
  null
  
)

export default component.exports